module.exports = __webpack_public_path__ + "img/laboratorio_16-9_1920.089f4267.webp";